<template>
  <Modal
    class="scoped"
    :modal-style="{ maxWidth: '900px' }"
    title="Archive Multiple Streams"
  >
    <div class="card q-pa-md column no-wrap full-height scroll">
      <StreamBulkSelect
        v-model="selectedStreams"
        :organisation-id="organisationId"
        :stream-type="streamType"
        :users="users"
      />
    </div>

    <template #buttons>
      <BaseButton
        color="primary"
        label="Archive"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";

import StreamBulkSelect from "src/components/streams/StreamBulkSelect.vue";

export default {
  name: "ArchiveMultipleStreamsModal",
  components: {
    Modal,
    BaseButton,
    StreamBulkSelect,
  },
  props: {
    organisationId: {
      type: [Number, String],
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    streamType: {
      type: [Number, String],
      required: true,
    },
  },
  emits: ["confirm", "close"],
  data() {
    return {
      selectedStreams: [],
    };
  },
  methods: {
    confirm() {
      this.$emit("confirm", this.selectedStreams);
      this.$emit("close");
    },
  },
};
</script>
